
import 'ng-table/dist/ng-table'


var controllersModule =  angular.module('controllers',['ngTable']);
export default controllersModule.name;